@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

/* stylelint-disable css-modules/no-global-scoped-selector */
:root {
  --toolbar-animation-duration: 320ms;
  --toolbar-animation-ease: cubic-bezier(0.2, 0.8, 0.2, 1);
}
/* stylelint-enable css-modules/no-global-scoped-selector */

[data-ff-post-approvals='on'] {
  .toolbar {
    width: 250px;
  }

  .innerToolbar {
    gap: 18px;
  }
}

.toolbar {
  position: relative;
  top: auto;
  right: auto;
  transform: none;
  display: flex;
  flex-direction: column;
  z-index: 100000;
  width: 250px;
  background: var(--light-100);
  height: 100%;
  border-top: 1px solid var(--dark-4);
}

.innerToolbar {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 15px 0 15px 15px;
  margin-right: 15px;
}

.toolbarItem {
  transition: all var(--toolbar-animation-duration) var(--toolbar-animation-ease);
}

.toolbarMenu {
  display: flex;
  flex-direction: column;
  gap: 5px;

  &.inDesigner {
    gap: 5px;
  }
}

.toolbarMenuHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 28px;
}

.navigationButtons {
  display: flex;
  justify-content: space-between;
  padding: 12px 12px 0 12px;
  border-left: 1px solid var(--dark-4);
}

.scheduledPostTargetsContainer {
  overflow: hidden;
  transform-origin: top;
  transition: transform var(--toolbar-animation-duration) var(--toolbar-animation-ease),
    opacity var(--toolbar-animation-duration) var(--toolbar-animation-ease),
    max-height var(--toolbar-animation-duration) var(--toolbar-animation-ease),
    margin var(--toolbar-animation-duration) var(--toolbar-animation-ease);
  will-change: transform, opacity, max-height, margin;

  &.visible {
    transform: scaleY(1);
    opacity: 1;
    max-height: 1000px;
    margin: 0;
  }

  &.hidden {
    transform: scaleY(0);
    opacity: 0;
    max-height: 0;
    margin: -30px -15px 0 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .toolbarItem,
  .scheduledPostTargetsContainer {
    transition: none !important;
  }

  .scheduledPostTargetsContainer {
    &.visible {
      transform: none;
      opacity: 1;
      max-height: none;
      margin: 0;
    }

    &.hidden {
      transform: none;
      opacity: 0;
      max-height: 0;
      margin: -30px 0 0 0;
    }
  }
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .bottomActions {
    display: flex;
    gap: 5px;
    align-items: center;

    > div {
      width: 100%;
    }
  }
}

.postSettings {
  background: linear-gradient(0deg, var(--selected-fill-10) 0%, var(--selected-fill-10) 100%), var(--light-100);
  padding: 15px;
  width: 100%;
  max-width: 800px;
  box-sizing: border-box;
  border-radius: 8px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  &.warning {
    background: var(--negative-10);
    border: 1px solid var(--negative-20);

    .postSettingsTextGroup {
      @include sm-sohne-medium;
      color: var(--red-70);
    }
  }
}

.actionButton {
  width: 100%;
}

.refreshButton {
  background: var(--light-100);
  flex-shrink: 0;
  white-space: nowrap;
}

.postSettingsTextGroup {
  @include sm-sohne;
  color: var(--dark-80);
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
  min-width: 0;
  overflow-wrap: break-word;
  word-break: break-word;
}

.postSettingsMessage {
  white-space: pre-line;
}

.postSettingsSecondaryMessage {
  @include sm-sohne;
  display: block;
  margin-top: 8px;
  color: var(--dark-80);
}

.CalendarButtonWrapper {
  width: 100%;
}

.CalendarButtonWrapperCompact {
  display: inline-flex;
  width: auto;
}

.CalendarButton {
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  align-self: stretch;

  border-radius: 8px;
  border: 1px solid var(--dark-15);
  background: var(--light-100);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: 0.28px;

  svg:last-child {
    margin-left: auto;
    width: 12px;
    height: 12px;
  }
}

.postedWrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.viewPostButton {
  width: 100%;
}
